import { QuizFileDropzone } from '@/components/assessments/QuizFileDropzone';
import { hasSelectableOptions } from './questionEditor';
import type { QuestionOptionDraft } from './questionEditor';

export interface QuestionAttemptPreviewProps {
  index?: number;
  stem: string;
  type: string;
  options?: QuestionOptionDraft[];
}

export function QuestionAttemptPreview({
  index = 0,
  stem,
  type,
  options = [],
}: QuestionAttemptPreviewProps) {
  const stemText = stem.trim() || 'El enunciado de la pregunta aparecerá aquí.';
  const visibleOptions = options.filter((opt) => opt.content.trim());

  return (
    <div className="lms-quiz-attempt lms-question-preview__quiz">
      <article className="lms-quiz-attempt__card">
        <p className="lms-quiz-question__label">
          Pregunta <span>{index + 1}</span>
        </p>
        <div className="lms-quiz-question__stem">
          <span className="lms-quiz-question__stem-text">{stemText}</span>
          <span className="lms-quiz-question__required">Requerida</span>
        </div>

        {type === 'true_false' ? (
          <fieldset className="lms-quiz-question__options">
            {(visibleOptions.length > 0 ? visibleOptions : [
              { label: 'V', content: 'Verdadero', is_correct: true },
              { label: 'F', content: 'Falso', is_correct: false },
            ]).map((opt, optIndex) => (
              <label key={`${opt.label}-${optIndex}`} className="lms-quiz-question__option">
                <input
                  type="radio"
                  className="lms-quiz-question__input"
                  name="preview-true-false"
                />
                <span className="lms-quiz-question__option-text">{opt.content}</span>
              </label>
            ))}
          </fieldset>
        ) : hasSelectableOptions(type) && visibleOptions.length > 0 ? (
          <fieldset className="lms-quiz-question__options">
            {visibleOptions.map((opt, optIndex) => (
              <label key={`${opt.label}-${optIndex}`} className="lms-quiz-question__option">
                <input
                  type={type === 'multiple_choice' ? 'checkbox' : 'radio'}
                  className="lms-quiz-question__input"
                  name={type === 'multiple_choice' ? `preview-option-${optIndex}` : 'preview-single'}
                />
                <span className="lms-quiz-question__option-text">
                  {opt.label ? (
                    <span className="lms-quiz-question__option-letter">{opt.label}.</span>
                  ) : null}
                  {opt.content}
                </span>
              </label>
            ))}
          </fieldset>
        ) : type === 'long_answer' ? (
          <textarea
            className="lms-quiz-question__text-input"
            rows={5}
            placeholder="Escribe tu respuesta…"
          />
        ) : type === 'short_answer' ? (
          <input
            type="text"
            className="lms-quiz-question__text-input lms-quiz-question__text-input--narrow"
            placeholder="Tu respuesta"
          />
        ) : type === 'file_upload' ? (
          <QuizFileDropzone name="preview-file" />
        ) : (
          <p className="text-sm text-dash-on-surface-variant">
            Vista previa no disponible para este tipo de pregunta.
          </p>
        )}
      </article>
    </div>
  );
}
